exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dot-status-container {\n  display: flex;\n  justify-content: center;\n  align-items: center; }\n  .dot-status-container svg {\n    margin: 10px;\n    color: #008cba; }\n", ""]);

// exports
